import { render, staticRenderFns } from "./ResourceEditTabAccount.vue?vue&type=template&id=8acedb4e&scoped=true&"
import script from "./ResourceEditTabAccount.vue?vue&type=script&lang=js&"
export * from "./ResourceEditTabAccount.vue?vue&type=script&lang=js&"
import style0 from "./ResourceEditTabAccount.vue?vue&type=style&index=0&id=8acedb4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8acedb4e",
  null
  
)

export default component.exports